export const DICT_CREATE_PAGE_PATH = '/dict/create'

export const DICT_EDIT_PAGE_PATH = '/dict/edit'

export const DICT_DETAIL_PAGE_PATH = '/dict/detail'

export const DICT_LIST_PAGE_PATH = '/dict/list'
